import * as React from 'react';
import './base.module.scss';

export const Header = ({ children }) => <div styleName="header">{children}</div>;
export const SubHeader = ({ children }) => <div styleName="sub-header">{children}</div>;
export const SubHeaderText = ({ children }) => <div styleName="sub-header-text">{children}</div>;
